export default __webpack_public_path__ + "static/media/icon-empty-templates.910913ef.svg";